const React = require('react');
const { useTranslation } = require('react-i18next');
const { buildBreadcrumb, getEntryDisplay } = require('./globalSearchHelpers');
const { ENTITY_TYPE_LABEL_KEYS } = require('./GlobalSearch.types');

const BREADCRUMB_SEPARATOR = ' › ';

const GlobalSearchResultRow = ({
  entry,
  index,
  isActive,
  onSelect,
  onHover,
  rowRef,
}) => {
  const { t } = useTranslation();
  const breadcrumb = buildBreadcrumb(entry);
  const { title, detail, typeLabel } = getEntryDisplay(entry);

  return (
    <div
      ref={rowRef}
      className={`globalSearchRow${isActive ? ' globalSearchRow--active' : ''}`}
      role='option'
      aria-selected={isActive}
      onClick={() => onSelect(index)}
      onMouseMove={() => onHover(index)}
    >
      <div className='globalSearchRow__main'>
        <span className='globalSearchRow__name'>{title}</span>
        {detail ? <span className='globalSearchRow__id'>{detail}</span> : null}
      </div>
      <div className='globalSearchRow__meta'>
        {breadcrumb.length > 0 ? (
          <span className='globalSearchRow__breadcrumb'>
            {breadcrumb.join(BREADCRUMB_SEPARATOR)}
          </span>
        ) : null}
        {/* Sensors show their product name; it already reads as "a sensor",
            so it replaces the generic badge rather than adding a second one. */}
        <span className='globalSearchRow__badge'>
          {typeLabel || t(ENTITY_TYPE_LABEL_KEYS[entry.type])}
        </span>
      </div>
    </div>
  );
};

module.exports = GlobalSearchResultRow;
